module.exports = __webpack_public_path__ + "static/media/birthday2023_cake.88c30cda.gif";